import React, { SVGProps } from 'react'
const SvgUpdate = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M9.068 20.537a.75.75 0 0 1-.523.213H5a.75.75 0 0 1-.75-.75v-3.545a.75.75 0 0 1 .213-.523L15.462 4.646a.769.769 0 0 1 .003-.003l1.874-1.874a1.767 1.767 0 0 1 2.502 0l2.39 2.39c.692.692.692 1.81 0 2.502l-1.868 1.868a1.04 1.04 0 0 1-.01.01L9.069 20.536ZM21.171 6.6a.268.268 0 0 0 0-.38L18.78 3.83a.267.267 0 0 0-.38 0l-1.34 1.339 2.771 2.77 1.34-1.34ZM5.75 16.76v2.49h2.49L18.764 8.993l-2.757-2.757L5.75 16.76Z"
    />
  </svg>
)
export default SvgUpdate
